import apiClient, { unwrap } from './client'
import type { MxRecord, ServerConfig } from './types'

export interface ServerConfigInput {
  smtp_port: number
  default_forward_email?: string | null
  allow_inbound: boolean
  allow_outbound: boolean
  mx_records?: MxRecord[]
  server_ip?: string
}

export const serverConfigApi = {
  get() {
    return unwrap<ServerConfig>(apiClient.get('/server-config'))
  },
  put(input: ServerConfigInput) {
    return unwrap<ServerConfig>(apiClient.put('/server-config', input))
  },
}